// extracted by mini-css-extract-plugin
export default {"redirect_background":"RedirectToExternal_redirect_background__UUEV1"};